import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue";
import _imports_0 from '@/assets/img/robot.jpg';
const _hoisted_1 = {
  class: "main-page"
};
const _hoisted_2 = {
  class: "top-section"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = {
  class: "left_box"
};
const _hoisted_5 = {
  class: "content"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  class: "box"
};
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = {
  class: "center"
};
const _hoisted_12 = {
  class: "box"
};
const _hoisted_13 = {
  class: "right"
};
const _hoisted_14 = {
  class: "right_box"
};
const _hoisted_15 = {
  class: "content"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  class: "box"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = ["src"];
const _hoisted_20 = ["innerHTML"];
const _hoisted_21 = {
  class: "middle-section"
};
const _hoisted_22 = {
  class: "left"
};
const _hoisted_23 = {
  class: "left_box"
};
const _hoisted_24 = {
  class: "content"
};
const _hoisted_25 = ["onClick"];
const _hoisted_26 = {
  class: "box"
};
const _hoisted_27 = ["src"];
const _hoisted_28 = ["innerHTML"];
const _hoisted_29 = {
  class: "right"
};
const _hoisted_30 = {
  class: "right_box"
};
const _hoisted_31 = {
  class: "content"
};
const _hoisted_32 = ["onClick"];
const _hoisted_33 = ["src"];
const _hoisted_34 = {
  class: "title"
};
const _hoisted_35 = {
  class: "bottom-section"
};
const _hoisted_36 = {
  class: "left"
};
const _hoisted_37 = ["onClick"];
const _hoisted_38 = {
  class: "box"
};
const _hoisted_39 = ["innerHTML"];
const _hoisted_40 = {
  class: "right"
};
const _hoisted_41 = ["onClick"];
const _hoisted_42 = {
  class: "box"
};
const _hoisted_43 = ["innerHTML"];
import CommonTit from "@/components/commonTit.vue";
import api from '@/server/request/api';
import { ElMessage } from 'element-plus';
import { reactive, onMounted, ref } from "vue";
import { useRouter } from 'vue-router';
import left1 from "@/assets/img/left1.png";
import left2 from "@/assets/img/left2.png";
import left3 from "@/assets/img/left3.png";
import left4 from "@/assets/img/left4.png";
import right1 from "@/assets/img/right1.png";
import right2 from "@/assets/img/right2.png";
import right3 from "@/assets/img/right3.png";
import right4 from "@/assets/img/right4.png";
import middleleft1 from "@/assets/img/middleleft1.png";
import middleleft2 from "@/assets/img/middleleft2.png";
import middleleft3 from "@/assets/img/middleleft3.png";
import middleright1 from "@/assets/img/middleright1.png";
import middleright2 from "@/assets/img/middleright2.png";
import middleright3 from "@/assets/img/middleright3.png";
import system_bj from "@/assets/img/system_bj.png";
import system_bj2 from "@/assets/img/system_bj2.png";
import activeIndex from "@/assets/img/activeIndex.png";
import activeIndex1 from "@/assets/img/activeIndex1.png";
import DialogVideo from "@/views/explanatoryVideo/index.vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    // Define the type for the DialogVideo component
    const logVideo = ref(null); // Explicitly define the type
    const state = reactive({
      cent: {
        title: "坤宁<span style='display:inline-block;transform:translateY(-5px)'>®</span>数字人智能体",
        img: right1,
        id: '01024',
        url: 'https://znt.zkjldata.com/login',
        videoUrl: 'https://dp.54zkjl.com/公司产品视频/金坤/金坤办案辅助系统.mp4'
      },
      leftContent: [{
        title: "<div style='transform:translate(-10px,15px)'><div>重点人</div>网络足迹监测系统</div>",
        img: left1,
        id: '01001',
        url: 'https://lz4demo.54zkjl.com/#/loginPKI',
        videoUrl: 'https://dp.54zkjl.com/公司产品视频/猎寻/网络足迹4.0.mp4'
      }, {
        title: "重点人身份识别系统",
        img: left2,
        id: '01002',
        url: window.configs.KEY_POINT_PERSON_URL,
        videoUrl: 'https://dp.54zkjl.com/公司产品视频/猎寻/重点人员身份识别.mp4'
      }, {
        title: "手机号翻译系统",
        img: left3,
        id: '01003',
        url: 'https://lz4demo.54zkjl.com/fyxt/#/login',
        videoUrl: 'https://dp.54zkjl.com/公司产品视频/猎寻/手机号翻译.mp4'
      }, {
        title: "手机点验取证系统",
        img: left4,
        id: '01004',
        url: 'https://jktio.54zkjl.com/#/login',
        videoUrl: 'https://dp.54zkjl.com/公司产品视频/猎寻/手机信息采集系统.mp4'
      }],
      rightContent: [{
        title: "网络视频监测系统",
        img: right1,
        id: '01005',
        url: 'http://spfx.54zkjl.com/',
        videoUrl: 'https://dp.54zkjl.com/公司产品视频/听风者/网络视频监测-1.mp4'
      }, {
        title: "TT情报分析系统",
        img: right2,
        id: '01006',
        url: 'http://10.10.0.27/#/login',
        videoUrl: 'https://dp.54zkjl.com/公司产品视频/听风者/听风者TT情报分析.mp4'
      }, {
        title: "开源情报分析系统",
        img: right3,
        id: '01007',
        url: 'http://120.220.138.81:8689/#/login',
        videoUrl: 'https://dp.54zkjl.com/公司产品视频/听风者/听风者5.0.mp4'
      }, {
        title: "声像鉴伪取证系统",
        img: right4,
        id: '01008',
        url: window.configs.SOUND_IMAGE_PROOF_URL
      }],
      leftContent2: [{
        title: "异常行为监测系统",
        img: middleleft1,
        id: '01009',
        url: window.configs.ABNORMAL_BEHAVIOR_MONITORING_SYSTEM_URL
      }, {
        title: "<div> <div>非接触式</div>心理健康预警系统</div>",
        img: middleleft2,
        id: '01010',
        url: window.configs.PSYCHOLOGICAL_HEALTH_URL,
        videoUrl: 'https://dp.54zkjl.com/公司产品视频/智眼/非接触式心理健康预警系统.mp4'
      }, {
        title: "交互式干预座舱",
        img: middleleft3,
        id: '01011',
        url: window.configs.INTERACTIVE_INTERVENTION_SEAT_CABIN_URL
      }],
      rightContent2: [{
        title: "卷宗管理系统",
        img: middleright1,
        id: '01012',
        url: window.configs.CASE_MANAGEMENT_SYSTEM_URL,
        videoUrl: 'https://dp.54zkjl.com/公司产品视频/联石/卷宗管理系统.mp4'
      }, {
        title: "智慧笔录系统",
        img: middleright2,
        id: '01013',
        url: window.configs.SMART_RECORD_SYSTEM_URL,
        videoUrl: 'https://dp.54zkjl.com/公司产品视频/联石/联石智慧笔录系统.mp4'
      }, {
        title: "案件管理系统",
        img: middleright2,
        id: '01023',
        url: 'http://10.10.0.29:81/login',
        videoUrl: 'https://dp.54zkjl.com/公司产品视频/联石/问题线索管理系统.mp4'
      }, {
        title: "保卫工作数据平台",
        img: middleright3,
        id: '01014',
        url: 'http://192.168.179.174:81/login',
        videoUrl: 'https://dp.54zkjl.com/公司产品视频/联石/保卫系统-1.mp4'
      }],
      btmLeft: [{
        title: "<div><div >猎盾<span style='display:inline-block;transform:translateY(-6px)'>®</span>异常信号</div>检测系统</div>",
        id: '01015',
        url: ''
      }, {
        title: "<div><div>猎盾<span style='display:inline-block;transform:translateY(-6px)'>®</span>属地无人机</div>管控系统</div>",
        id: '01016',
        url: ''
      }, {
        title: "<div><div>猎盾<span style='display:inline-block;transform:translateY(-6px)'>®</span>访客</div>身份核验系统</div>",
        id: '01017',
        url: ''
      }, {
        title: "<div><div>猎盾<span style='display:inline-block;transform:translateY(-6px)'>®</span>防拍照</div>显示屏</div>",
        id: '01018',
        url: ''
      }],
      btmRight: [{
        title: "<div><div>猎盾<span style='display:inline-block;transform:translateY(-6px)'>®</span>会议室</div>手机屏蔽器</div>",
        id: '01019',
        url: ''
      }, {
        title: "<div><div>猎盾<span style='display:inline-block;transform:translateY(-6px)'>®</span>防录音</div>系统</div>",
        id: '01020',
        url: ''
      }, {
        title: "<div><div>猎盾<span style='display:inline-block;transform:translateY(-6px)'>®</span>苹果设备</div>发现系统</div>",
        id: '01021',
        url: ''
      }, {
        title: "<div><div>猎盾<span style='display:inline-block;transform:translateY(-6px)'>®</span>物联网设备</div>勘查平台</div>",
        id: '01022',
        url: ''
      }],
      activeIndex: '',
      condition: true,
      videoUrl: 'your_video_url_here',
      item: {} // Initialize item with the Item type
    });
    onMounted(() => {
      checkLogin();
    });
    const handleClose = () => {
      if (state.item.url) {
        if (state.item.url !== 'http://spfx.54zkjl.com/') {
          api.getUserInfo({
            sysName: state.item.id
          }).then(resp => {
            if (resp.code === 200) {
              console.log(resp);
              let url = state.item.url + '?username=' + resp.result.sysAccount + '&password=' + resp.result.sysPassword;
              window.open(url, '_blank');
            } else {
              ElMessage.error('获取用户信息失败');
            }
          });
        } else {
          api.getToken().then(resp => {
            if (resp.code === 200) {
              console.log(resp.result.token);
              document.cookie = 'remember_user_token=' + resp.result.token + ';domain=.54zkjl.com;';
              window.open('http://spfx.54zkjl.com');
            } else {
              ElMessage.error('获取token失败');
            }
          });
        }
      }
    };
    const handleClick = item => {
      state.activeIndex = item.title;
      state.item = item;
      if (logVideo.value && item.videoUrl) {
        logVideo.value.openDialog(item.videoUrl);
      } else {
        handleClose();
      }
    };
    // const handleClick = (item: any) => {
    //   state.activeIndex = item.title;
    //   if (item.url) {
    //     if (item.url !== 'http://spfx.54zkjl.com/') {
    //       api.getUserInfo({ sysName: item.id }).then((resp: ObjParams) => {
    //         if (resp.code === 200) {
    //           console.log(resp);
    //           let url = item.url + '?username=' + resp.result.sysAccount + '&password=' + resp.result.sysPassword;
    //           window.open(url, '_blank');
    //         } else {
    //           ElMessage.error('获取用户信息失败');
    //         }
    //       });
    //     } else {
    //       api.getToken().then((resp: ObjParams) => {
    //         if (resp.code === 200) {
    //           console.log(resp.result.token);
    //           document.cookie = 'remember_user_token=' + resp.result.token + ';domain=.54zkjl.com;';
    //           window.open('http://spfx.54zkjl.com')
    //         } else {
    //           ElMessage.error('获取token失败');
    //         }
    //       });
    //     }
    //   }
    // };
    // 检查是否登录
    const checkLogin = () => {
      api.checkLogin().then(resp => {
        if (resp.code === 200) {
          console.log(resp);
          if (!resp.result.isLogin) {
            router.push('/login');
          }
        } else {
          ElMessage.error('获取用户信息失败');
        }
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(DialogVideo, {
        ref_key: "logVideo",
        ref: logVideo,
        onClose: handleClose
      }, null, 512), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(CommonTit, {
        title: "网络行为筛查--猎寻<span style='display:inline-block;transform:translateY(-8px)'>®</span>系列"
      }), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.leftContent, (item, i) => {
        return _openBlock(), _createElementBlock("div", {
          key: i,
          class: "item",
          onClick: $event => handleClick(item)
        }, [_createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
          class: "img",
          src: state.activeIndex === item.title && i !== 1 ? _unref(activeIndex) : state.activeIndex === item.title && i == 1 ? _unref(activeIndex1) : i === 1 ? _unref(system_bj2) : _unref(system_bj),
          alt: ""
        }, null, 8, _hoisted_8), _createElementVNode("img", {
          class: "img_content",
          src: item.img,
          alt: ""
        }, null, 8, _hoisted_9), _createElementVNode("div", {
          class: "title",
          innerHTML: item.title
        }, null, 8, _hoisted_10)])], 8, _hoisted_6);
      }), 128))])])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
        class: "box_top",
        onClick: _cache[0] || (_cache[0] = $event => handleClick(state.cent))
      }, [...(_cache[1] || (_cache[1] = [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      }, null, -1), _createElementVNode("div", {
        class: "text"
      }, [_createTextVNode(" 金坤"), _createElementVNode("span", {
        style: {
          "display": "inline-block",
          "transform": "translateY(-5px)"
        }
      }, "®"), _createTextVNode("办案智能体 ")], -1)]))]), _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "box_bottom"
      }, [_createElementVNode("div", {
        class: "num"
      }, [_createTextVNode(" 4 "), _createElementVNode("span", {
        style: {
          "color": "#000",
          "font-size": "24px",
          "font-weight": "bold"
        }
      }, "块")]), _createElementVNode("div", {
        class: "text"
      }, " 核心业务 ")], -1))])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(CommonTit, {
        title: "听风者<span style='display:inline-block;transform:translateY(-8px)'>®</span>系列--认知情报大模型",
        isFlipped: ""
      }), _createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.rightContent, (item, i) => {
        return _openBlock(), _createElementBlock("div", {
          key: i,
          class: "item",
          onClick: $event => handleClick(item)
        }, [_createElementVNode("div", _hoisted_17, [_createElementVNode("img", {
          class: "img",
          src: state.activeIndex === item.title && i !== 0 ? _unref(activeIndex) : state.activeIndex === item.title && i == 0 ? _unref(activeIndex1) : i === 0 ? _unref(system_bj2) : _unref(system_bj),
          alt: ""
        }, null, 8, _hoisted_18), _createElementVNode("img", {
          class: "img_content",
          src: item.img,
          alt: ""
        }, null, 8, _hoisted_19), _createElementVNode("div", {
          class: "title",
          innerHTML: item.title
        }, null, 8, _hoisted_20)])], 8, _hoisted_16);
      }), 128))])])])]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createVNode(CommonTit, {
        title: "心理健康筛查--智眼<span style='display:inline-block;transform:translateY(-8px)'>®</span>系列"
      }), _createElementVNode("div", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.leftContent2, (item, i) => {
        return _openBlock(), _createElementBlock("div", {
          key: i,
          class: _normalizeClass(["item", {
            'active': state.activeIndex === item.title
          }]),
          onClick: $event => handleClick(item)
        }, [_createElementVNode("div", _hoisted_26, [_createElementVNode("img", {
          class: "img",
          src: item.img,
          alt: ""
        }, null, 8, _hoisted_27), _createElementVNode("div", {
          class: "title",
          innerHTML: item.title
        }, null, 8, _hoisted_28)])], 10, _hoisted_25);
      }), 128))])])]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createVNode(CommonTit, {
        title: "联石<span style='display:inline-block;transform:translateY(-8px)'>®</span>系列--智慧保卫平台",
        isFlipped: ""
      }), _createElementVNode("div", _hoisted_31, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.rightContent2, (item, i) => {
        return _openBlock(), _createElementBlock("div", {
          key: i,
          class: _normalizeClass(["item", {
            'active': state.activeIndex === item.title
          }]),
          onClick: $event => handleClick(item)
        }, [_createElementVNode("div", {
          class: _normalizeClass(["box", {
            'active': state.activeIndex === item.title
          }])
        }, [_createElementVNode("img", {
          class: "img",
          src: item.img,
          alt: ""
        }, null, 8, _hoisted_33), _createElementVNode("div", _hoisted_34, _toDisplayString(item.title), 1)], 2)], 10, _hoisted_32);
      }), 128))])])]), _cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "middle_box"
      }, [_createElementVNode("div", {
        class: "box_top"
      }, [_createElementVNode("div", {
        class: "num"
      }, "1"), _createElementVNode("div", {
        class: "text"
      }, "个数据中心")])], -1))]), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.btmLeft, (item, i) => {
        return _openBlock(), _createElementBlock("div", {
          key: i,
          class: "item",
          onClick: $event => handleClick(item)
        }, [_createElementVNode("div", _hoisted_38, [_createElementVNode("div", {
          class: "title",
          innerHTML: item.title
        }, null, 8, _hoisted_39)])], 8, _hoisted_37);
      }), 128))]), _cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "center"
      }, [_createElementVNode("div", {
        class: "box"
      }, [_createElementVNode("div", {
        class: "num"
      }, "1"), _createElementVNode("div", {
        class: "text"
      }, "套安全装备")])], -1)), _createElementVNode("div", _hoisted_40, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.btmRight, (item, i) => {
        return _openBlock(), _createElementBlock("div", {
          key: i,
          class: "item",
          onClick: $event => handleClick(item)
        }, [_createElementVNode("div", _hoisted_42, [_createElementVNode("div", {
          class: "title",
          innerHTML: item.title
        }, null, 8, _hoisted_43)])], 8, _hoisted_41);
      }), 128))])])]);
    };
  }
});